import DetailOfMedia from './components/DetailOfMedia';
import RelatedContent from './components/RelatedContent';
import { IMediaAndContent } from '../../interfaces/MediaAndContent';
import ResponsiveContainer from '../../layouts/ResponsiveContainer';
import { useLocation } from "react-router-dom";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import ContactSection from '../../components/Common/ContactSection';

interface ContentDetail {
    content: IMediaAndContent,
    relatedContent: IMediaAndContent[],
    titleRelatedContent: string,
    subPathRelatedContent: string,
    module: string,
}

const Index = ({ content, relatedContent, titleRelatedContent, subPathRelatedContent, module }: ContentDetail) => {
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const right = params.get("right");

    const breadcrumbName = right
        ? `Metodología de evaluación del derecho ${right.toLowerCase()}`
        : content?.titulo;

    return (
        <>
            <div className='mt-16 flex justify-center'>
                <ResponsiveContainer>
                    <Breadcrumbs baseName={breadcrumbName} />
                    <DetailOfMedia
                        id={content?.id}
                        descripcion={content?.descripcion}
                        titulo={content?.titulo}
                        categorias={content?.categorias}
                        imagen={content.imagen}
                        imagen_pie_1={content.imagen_pie_1}
                        imagen_pie_2={content.imagen_pie_2}
                        imagen_pie_3={content.imagen_pie_3}
                        fecha={content.fecha}
                        texto={content.texto}
                        pdf={content.pdf}
                        url={content.url}
                        module={module}
                    />
                    {relatedContent && relatedContent.length > 0
                        ? <div className='mt-12'>
                            <RelatedContent
                                title={titleRelatedContent}
                                relatedContent={relatedContent ?? []}
                                subPath={subPathRelatedContent}
                            />
                        </div>
                        : <></>
                    }
                </ResponsiveContainer>
            </div>
            <ContactSection />
        </>
    );
};

export default Index;
/*
Este componente es reutilizado en actividades e investigaciones y acciones
*/